import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [NgIf, MatProgressSpinner],
})
export class LoadingComponent {
  @Input()
  loading = true;
}
